var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1Key(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.17 32h-29a12.85 12.85 0 100 12h9.47l4.2-4.2 4.2 4.2h1.71L56 39.8l4.2 4.2h1l6.8-6-6.83-6zm-46.6 9.48A3.48 3.48 0 1118 38a3.47 3.47 0 01-3.43 3.48z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Key.25f6ebe7.svg";
export { SvgG1Key as ReactComponent };